import React, { useEffect } from "react";
import Cookies from "js-cookie";
import { handleLogout, decodeJWT } from "../helpers/common.helpers";

const AuthWatcher = ({ children }) => {
  useEffect(() => {
    // 1. Proactive Expiry Timer
    const token = Cookies.get("token");
    let expiryTimer;

    if (token) {
      const payload = decodeJWT(token);
      if (payload && payload.exp) {
        const timeout = (payload.exp * 1000) - Date.now();
        if (timeout > 0) {
          expiryTimer = setTimeout(() => {
            handleLogout();
          }, timeout);
        } else {
          handleLogout();
        }
      }
    }

    // 2. Cookie Heartbeat
    const heartbeat = setInterval(() => {
      if (!Cookies.get("token") && localStorage.getItem("user_id")) {
        handleLogout();
      }
    }, 5000);

    // 3. Cross-Tab Enrollment Sync
    const handleStorageChange = (e) => {
      if (e.key === "enrol_id" || e.key === "token_deleted") {
        window.location.reload();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      if (expiryTimer) clearTimeout(expiryTimer);
      clearInterval(heartbeat);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return <>{children}</>;
};

export default AuthWatcher;
